import { render, staticRenderFns } from "./modifyBinEntity.vue?vue&type=template&id=1d3c5cc9&"
import script from "./modifyBinEntity.vue?vue&type=script&lang=js&"
export * from "./modifyBinEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports